import { render, staticRenderFns } from "./GetFacebookLikes.vue?vue&type=template&id=3549e7d4&"
import script from "./GetFacebookLikes.vue?vue&type=script&lang=js&"
export * from "./GetFacebookLikes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports